export const colors = [
  // --- 10 softly darkened, visually distinct base colors ---
  '#51E5FF',
  '#975fcb',
  '#EC368D',
  '#72E172',
  '#FFACEC',
  '#FF8551',
  '#F1EC5B',
  '#4561FF',
  '#E82222',
  '#A3BFD0',

  // --- 10 secondary, slightly deeper accents ---
  '#D64545', // red
  '#E3A600', // dark yellow (can remove later if you want no yellows at all)
  '#04B48E', // green teal
  '#187FB5', // ocean blue
  '#8E58E5', // purple
  '#F06020', // orange-red
  '#359F85', // jade green
  '#EF476F', // coral pink
  '#3366CC', // vivid blue
  '#5E8B3D', // olive green
];
